import React from "react";
import {
  Select,
  Button,
  DatePicker,
  Space,
  Row,
  Col,
  Checkbox,
  Dropdown,
  Modal,
  Tooltip,
  Image,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import DriverLoginReportStore from "../store/DriverLoginReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";

import withRouter from "../withRouter";

import dayjs from "dayjs";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import VehicleStore from "../store/VehicleStore";
import RAGReportStore from "../store/RAGReportStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
const { RangePicker } = DatePicker;
const { Option } = Select;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 34) {
      val.width = 320;
    } else if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};

class RAGReport extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.ragReportStore = new RAGReportStore(this);

    this.driverLoginReportStore = new DriverLoginReportStore();
    this.vehicleStore = new VehicleStore();
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedDriver: [],
      selectedVehicle: [],
      selectAllDrivers: false,
      selectAllVehicles: false,
      companyId: "",
      pageNo: 1,
      offset: 0,
      limit: 50,
      modalVisible: false,
      column: "",
      filter: "",
      dateWiseReport: false,
      // fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      // toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      fromDate: dayjs().format("YYYY-MM-DD "),
      toDate: dayjs().format("YYYY-MM-DD "),

      Notcompany: false,
      Notdriver: false,
      Nottype: false,
      filterby: "Driver",
      notvehicle: false,

      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_DRIVER_NAME_"),
          dataIndex: "driver",
          key: "driver",
          width: "15%",
        },
        {
          title: context.translate("_VEHICLE_NUMBER_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "15%",
        },
        {
          title: context.translate("_DATE_"),
          dataIndex: "date",
          key: "date",
          width: "15%",
        },
        {
          title: context.translate("_FLEET_REPORTS_DISTANCE_"),
          dataIndex: "distanceTravel",
          key: "distanceTravel",
          width: "15%",
        },

        {
          title: context.translate("_HARSH_ACCEL_OCCURANCES_"),
          dataIndex: "acccount",
          key: "acccount",
          width: "15%",
        },

        {
          title: context.translate("_ACCELERATIONS_PER_KM_"),

          dataIndex: "accper100km",
          key: "accper100km",
          width: "15%",
        },
        {
          title: context.translate("_HARSH_BRAKE_OCCURRENCE_"),

          dataIndex: "brakecount",
          key: "brakecount",

          width: "15%",
        },
        {
          title: context.translate("_DECLARATION_PER_KM_"),
          dataIndex: "brakeper100km",
          key: "brakeper100km",
          width: "15%",
        },
        {
          title: context.translate("_HARSH_CORNER_OCCURRENCE_"),
          dataIndex: "harshCornering",
          key: "harshCornering",
          width: "15%",
        },
        {
          title: context.translate("_HARSH_CORNER_PER_KM_"),
          dataIndex: "harshCorneringper100km",
          key: "harshCorneringper100km",
          width: "15%",
        },

        {
          title: context.translate("_SEATBEALT_VIOLATION_TIME_"),
          dataIndex: "seatbeltViolationDuration",
          key: "seatbeltViolationDuration",
          width: "15%",
        },
        {
          title: context.translate("_SEATBEALT_VIOLATION_TIME_SEC_PER_KM_"),
          dataIndex: "seatbeltViolationper10km",
          key: "seatbeltViolationper10km",
          width: "15%",
        },
        {
          title: context.translate("_MAX_SPEED_EVENT_VALUE_"),
          dataIndex: "speedcount",
          key: "speedcount",
          width: "15%",
        },
        {
          title: context.translate("_OVERSPEEDING_TIME_"),
          dataIndex: "overSpeedviolationDuration",
          key: "overSpeedviolationDuration",
          width: "15%",
        },
        {
          title: context.translate("_OVERSPEEDING_TIME_SEC_PER_KM_"),
          dataIndex: "overSpeedviolationper10km",
          key: "overSpeedviolationper10km",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_SCORE_"),
          dataIndex: "score",
          key: "score",
          width: "15%",
          render: (value) => {
            if (value >= 0 && value <= 1.99) {
              return (
                <div
                  className="ragScoreColor"
                  style={{
                    backgroundColor: "green",
                  }}
                >
                  {value}
                </div>
              );
            } else if (value >= 2 && value <= 4.99) {
              return (
                <div
                  className="ragScoreColor"
                  style={{
                    backgroundColor: "#FFBF00",
                  }}
                >
                  {value}
                </div>
              );
            } else if (value > 4.99) {
              return (
                <div
                  className="ragScoreColor"
                  style={{
                    backgroundColor: "red",
                  }}
                >
                  {value}
                </div>
              );
            }
          },
        },
      ]),
    };
    this.menuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXCEL_"),
          key: "excel",
        },
        {
          // label: "CSV",
          label: context.translate("_PDF_"),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            Driver: this.state.selectedDriver,
            reportType: this.state.reportType,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            // userId:JSON.parse(base64_decode(Cookies.get("data"))).userId,
            // userId: 1,
            // filter: this.state.filter,

            colList: result.toString(),
          };
          if (val.key == "excel") {
            // console.log("afd")
            this.ragReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.ragReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    // await this.ragReportStore.loadData({ offset: 0, limit: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      await this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({ selectedDriver: [], selectAllDrivers: false });
    await this.setState({ selectedVehicle: [], selectAllVehicles: false });

    await this.driverLoginReportStore.getDriversByCompanyId({
      companyId: comp?.value,
    });

    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ Notdriver: false });
    await this.ragReportStore.loadData({
      offset: (this.state.pageNo - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      pageNo: this.state.pageNo,
    });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });

    await this.showData();
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }

    if (!this.state.reportType) {
      this.setState({ Nottype: true });
    } else {
      this.setState({ Nottype: false });
    }
    if (
      (this.state.companyId &&
        this.state.selectedDriver.length > 0 &&
        this.state.reportType) ||
      (this.state.companyId &&
        this.state.selectedVehicle.length > 0 &&
        this.state.reportType)
    ) {
      this.setState({ mandatory: false });

      this.setState({
        Notcompany: false,
        Notdriver: false,
        notvehicle: false,
        Nottype: false,
      });

      await this.ragReportStore.loadData({
        offset: (this.state.pageNo - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        driverId: this.state.selectedDriver,
        vehicleId: this.state.selectedVehicle,
        filterBy: this.state.filterby,
        reportType: this.state.reportType,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        pageNo: this.state.pageNo,
      });
      console.log(this.ragReportStore?.total);

      await this.setState({ loadData: 1 });
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleSelectAllDrivers = async (e) => {
    if (this.state.selectAllDrivers) {
      const allDrivers = this.driverLoginReportStore?.getDrivers.map((val) => {
        return val.driverId;
      });
      await this.setState({ selectedDriver: allDrivers });
    } else {
      await this.setState({ selectedDriver: [] });
    }
  };

  handleSelectAllVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicle: allVehicles });
    } else {
      await this.setState({ selectedVehicle: [] });
    }
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD";

      this.setState({
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };

  selectTypeofDate = (value) => {
    if (value == "3" || value == "2") {
      this.setState({ dateWiseReport: true });
      this.setState({ monthWiseReport: false });
    } else if (value == "1") {
      this.setState({ dateWiseReport: false });
      this.setState({ monthWiseReport: true });
    }
  };

  refreshList = async () => {
    await this.setState({
      loading: false,
      current: 1,
      currentPage: 1,
      pageNo: 1,
    });
    await this.showData();
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_RAG_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.ragReportStore?.ragReportData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                    // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />

                {/* <Select
                  style={{ width: 150 }}
                  placeholder={this.context.translate("_FILTER_BY_")}
                  onChange={(val) => {
                    this.setState({ filterby: val });
                  }}
                >
                  <Select.Option value="Driver">
                    {this.context.translate(
                      "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                    )}
                  </Select.Option>

                  <Select.Option value="Vehicle">
                    {this.context.translate("_VEHICLES_")}
                  </Select.Option>
                </Select> */}

                {this.state.filterby == "Driver" && (
                  <>
                    <Checkbox
                      checked={this.state.selectAllDrivers}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllDrivers: e.target.checked,
                        });
                        if (this.state.selectAllDrivers) {
                          await this.setState({
                            Notdriver: false,
                          });
                        }
                        console.log(e.target.checked);
                        await this.handleSelectAllDrivers();
                      }}
                    />
                    {this.context.translate("_ALL_")}
                    <Select
                      className="searchInput"
                      // onSearch={this.handleSearch}
                      mode="multiple"
                      value={this.state.selectedDriver}
                      maxTagCount="responsive"
                      onChange={(val) => {
                        this.setState({
                          selectedDriver: val,
                          Notdriver: false,
                        });
                        if (
                          this.driverLoginReportStore?.getDrivers.length >
                          val.length
                        ) {
                          this.setState({ selectAllDrivers: false });
                        } else {
                          this.setState({ selectAllDrivers: true });
                        }
                      }}
                      placeholder={this.context.translate(
                        "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                      )}
                      optionFilterProp="children"
                      style={{ width: 150 }}
                      // style={DriverInputStyle}
                      status={this.state.Notdriver ? "error" : false}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.driverLoginReportStore?.getDrivers?.map((val) => {
                        return <Option value={val.driverId}>{val.name}</Option>;
                      })}
                    </Select>
                  </>
                )}

                {this.state.filterby === "Vehicle" && (
                  <>
                    {this.props.getUserData().isadmin === 1 && (
                      <DeviceGroupsForVehicles
                        className="searchInput"
                        vehicleStore={this.vehicleStore}
                        setLoadDta={() => this.setState({ loadData: 1 })}
                        resetVehicles={() =>
                          this.setState({
                            selectedVehicle: [],
                            selectAllVehicles: false,
                          })
                        }
                      />
                    )}
                    <Checkbox
                      checked={this.state.selectAllVehicles}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllVehicles: e.target.checked,
                        });
                        if (this.state.selectAllVehicles) {
                          await this.setState({
                            notvehicle: false,
                          });
                        }
                        console.log(e.target.checked);
                        await this.handleSelectAllVehicles();
                      }}
                    />
                    {this.context.translate("_ALL_")}

                    <Select
                      className="searchInput"
                      maxTagCount="responsive"
                      value={this.state.selectedVehicle}
                      onChange={(val) => {
                        this.setState({
                          selectedVehicle: val,
                          notvehicle: false,
                        });
                        if (
                          this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                          val.length
                        ) {
                          this.setState({ selectAllVehicles: false });
                        } else {
                          this.setState({ selectAllVehicles: true });
                        }
                      }}
                      style={{ width: 200 }}
                      showSearch
                      status={this.state.notvehicle ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                        (val) => {
                          return (
                            <Option value={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  </>
                )}

                <Select
                  className="searchInput"
                  style={{ width: 150 }}
                  // style={TypeInputStyle}
                  status={this.state.Nottype ? "error" : false}
                  onSelect={async (value) => {
                    console.log(value);
                    await this.setState({ reportType: value, Nottype: false });
                    // await this.handleSearch()
                  }}
                  onChange={(value) => this.selectTypeofDate(value)}
                  // placeholder="Type"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_NEWPOI_TYPE_"
                  )}
                >
                  <Select.Option value="3">Datewise Report</Select.Option>
                  <Select.Option value="2">Weekly Report</Select.Option>
                  <Select.Option value="1">Monthly Report</Select.Option>
                </Select>
                {this.state.dateWiseReport && (
                  <>
                    <DatePicker
                      style={{ borderRadius: "25px" }}
                      format={"YYYY-MM-DD"}
                      disabledDate={(current) => {
                        return current && current > dayjs();
                      }}
                      defaultValue={dayjs()}
                      onChange={(date) => {
                        // console.log(date)
                        this.setState({ fromDate: date.format("YYYY-MM-DD") });
                      }}
                      // style={{ width: "100%" }}
                    />
                    <DatePicker
                      style={{ borderRadius: "25px" }}
                      format={"YYYY-MM-DD"}
                      disabledDate={(current) => {
                        return current && current > dayjs();
                      }}
                      onChange={(date) => {
                        // console.log(date)
                        this.setState({ toDate: date.format("YYYY-MM-DD") });
                      }}
                      defaultValue={dayjs()}
                      // style={{ width: "100%" }}
                    />
                  </>
                )}
                {this.state.monthWiseReport && (
                  <>
                    <RangePicker
                      // placeholder={["From Month", "To Month"]}
                      format="MM-YYYY"
                      picker="month"
                      style={{ width: 300, borderRadius: "25px" }}
                      onChange={(val) => {
                        this.onDateTimeChange(val);
                      }}
                      disabledDate={(current) => {
                        return current && current > dayjs();
                      }}
                      showTime={{
                        format: "h:mmA",
                        defaultValue: [dayjs().startOf("day"), dayjs()],
                      }}
                      defaultValue={[dayjs().startOf("day"), dayjs()]}
                    />
                  </>
                )}
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                    this.setState({ pageNo: 1 });
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.ragReportStore?.ragReportData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.pageNo}
            pageSize={this.state.pageSize}
            total={this.ragReportStore?.total}
            columns={this.state.column}
            dataSource={this.ragReportStore?.ragReportData}
            loading={this.ragReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </>
    );
  }
}
RAGReport.contextType = StoreContext;
export default observer(withRouter(RAGReport));
